import axiosInstance from "../../plugins/axios-common";
import axios from "../../plugins/axios-common";

export default {
	actions: {
		getClientsByPlate (value) {
			return new Promise((resolve, reject) => {
				const formData = new FormData()
				formData.append('plateNumber', value);
				axios({
					method: 'POST',
					url: '/client/getclientsbyplate',
					data: formData,
				})
					.then((response) => {
						console.log('plates', response)
						resolve(response)
					}).catch((e) => {
					reject(e)
				})
			})
		},
		fetchClient({ commit }, payload) {
			return new Promise((resolve, reject) => {
				const body = {searchString: payload.searchString, type: payload.type}
				const settings = {
					method: 'POST',
					data: body,
					headers: {
						Accept: 'application/json',
						'Content-Type': 'application/json'
					}
				}
				axios("/client/client.json", settings).then((res) => {
					const client = res.data
					commit('updateClient', client)
					if (client.clientType) {
						commit('updateClientType', client.clientType)
					}
					resolve(client)
				}).catch((e) => {
					console.log('Error', e)
					reject(e)
				})
			})
		},
		fetchLegalClients({commit}) {
			return new Promise((resolve, reject) => {
				axiosInstance({
					method: 'get',
					url: '/client/legalclients.json',
				}).then((response) => {
					commit('updateLegalClients', response.data)
					resolve(response)
				}).catch((e) => {
					reject(e)
				})
			})
		},
		fetchClientCars({commit, state}) {
			const body = { userId: state.client.id }
			const settings = {
				method: 'POST',
				url: "/client/clientcars.json",
				data: body,
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				}
			}
			axios(settings).then((response) => {
				commit('updateClientCars', response.data)
			})
		},
		saveNewClient({ commit }, payload){
			return new Promise((resolve, reject) => {
				const settings = {
					method: 'POST',
					data: payload,
					headers: {
						Accept: 'application/json',
						'Content-Type': 'application/json',
					}
				}
				axios("/client/new", settings).then((res) => {
					const client = res.data
					commit('updateClient', client)
				}).then(() => {
					resolve()
				}).catch((e) => {
					reject(e.response.data)
				})
			})
		},
		saveOldClientDetails({ commit }, payload) {
			const body  = {'name': payload.name, 'surname': payload.surname, 'phone': payload.phone, 'user101_id': payload.clientId }
			const settings = {
				method: 'POST',
				data: body,
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
				}
			}
			axios("/client/update101", settings).then((res) => {
				const client = res.data
				commit('updateClient', client)
			})
		},
		fetchDiscounts() {
			return new Promise((resolve, reject) => {
				axios.get("/api/cash/discounts").then((resp) => {
					resolve(resp);
				}).catch((err) => {
					reject(err);
				});
			});
		}
	},
	mutations: {
		updateClient(state, client) {
			state.client = client
		},
		updateClientCars(state, clientCars) {
			state.clientCars = clientCars
		},
		setClientError(state, error) {
			state.clientError = error
		},
		updateLegalClients(state, legalClients) {
			state.legalClients = legalClients
		},
		updateChosenLegal(state, chosenLegal) {
			state.chosenLegal = chosenLegal
		},
		updateClientId(state, id) {
			state.client.id = id
		},
		setLicensePlate(state, payload) {
			state.client.customer.licensePlate = payload
		},
		setClientPhone(state, payload) {
			state.client.customer.phone = payload
		},
		resetClient(state) {
			state.client = {
				discount: {},
				additional_discount: {},
				customer: {
					agreement: false,
					name: '',
					surname: '',
					family: '',
					licensePlate: '',
					phone: '',
				},
				id: '',
				spent: 0,
			},
				state.clientError = '',
				state.chosenLegal = ''
			state.clientType = 'client'
		},
		anonymousClient(state) {
			state.client = {
				discount: {
					value: 0
				},
				additional_discount: {
					value: 0
				},
				customer: {
					licensePlate: '',
					phone: ''
				},
				spent: 0,
			},
				state.clientType = 'wodiscount'
			state.clientError = ''
		},
		loadClientFromLegal(state) {
			if(state.chosenLegal) {
				state.client.customer.name = state.chosenLegal.name
				state.client.customer.phone = state.chosenLegal.user.phone
				state.client.discount.card_number = state.chosenLegal.discount_card.code
				state.client.discount.value = state.chosenLegal.discount_card.discount
				state.client.additional_discount.value = state.chosenLegal.discount_card.additional_discount
				state.clientType = 'legal'
				state.client.id = state.chosenLegal.user.id
			}
		},
		updateClientType(state, value) {
			state.clientType = value
		},
		updateCardNumber(state, value) {
			state.client.discount.card_number = value
		}
	},
	state: {
		client: {
			discount: {
				card_number: '',
				value: 0
			},
			additional_discount: {
				value: 0
			},
			customer: {
				agreement: false,
				name: '',
				surname: '',
				family: '',
				licensePlate: '',
				phone: '',
			},
			spent: 0,
		},
		clientType: 'wodiscount',
		legalClients: {},
		chosenLegal: '',
		clientError: '',
		clientCars: {}
	},
	getters: {
		client(state) {
			return state.client
		},
		clientType(state) {
			return state.clientType
		},
		legalClients(state) {
			return state.legalClients
		},
		chosenLegal(state) {
			return state.chosenLegal
		},
		clientError(state) {
			return state.clientError
		},
		clientCars(state) {
			return state.clientCars
		},
		card_number(state) {
			return state.client.discount.card_number
		}
	}
}
